import { Client } from '../../models/organization/client.model';
import { ClientBillingRun, ClientBillingRunListItem } from '../../models/organization/client-billing-run.model';
import { BillingItemType } from '../../models/organization/billing-item-type.model';
import { BillingSssBracket } from '../../models/organization/billing-sss-bracket.model';
import { Deployment } from '../../models/organization/deployment.model';
import { Department } from '../../models/organization/department.model';
import { Branch } from '../../models/organization/branch.model';
import { Position } from '../../models/organization/position.model';
import { WorkSchedule } from '../../models/organization/work-schedule.model';

export interface IOrganizationState {
  clients: Client[];
  deployments: Deployment[];
  billingRuns: ClientBillingRunListItem[];
  selectedBillingRun: ClientBillingRun | null;
  billingItemTypes: BillingItemType[];
  billingSssBrackets: BillingSssBracket[];
  departments: Department[];
  branches: Branch[];
  positions: Position[];
  filteredPositions: Position[];
  workSchedules: WorkSchedule[];
  loading: boolean;
  error: string | null;
}

export const initialOrganizationState: IOrganizationState = {
  clients: [],
  deployments: [],
  billingRuns: [],
  selectedBillingRun: null,
  billingItemTypes: [],
  billingSssBrackets: [],
  departments: [],
  branches: [],
  positions: [],
  filteredPositions: [],
  workSchedules: [],
  loading: false,
  error: null,
};
